import { t } from "i18next"
import { localisedValue } from "utils"

const leadResharingReasonsTransformer = response => {
  const transformedArray = response.map(data => {
    return {
      label: localisedValue({ object: data, key: "reason" }),
      value: data?.id,
      key: data.key,
      id: data?.id,
    }
  })
  transformedArray.push({ label: t("Others"), value: "-1", key: "others", id: -1 })
  return transformedArray
}

export default leadResharingReasonsTransformer
